<script>
  import { Title, Content } from '@smui/paper';
  import Button, { Label, Icon } from '@smui/button';
  import Checkbox from '@smui/checkbox';
  import FormField from '@smui/form-field';
  import { createEventDispatcher } from 'svelte';
  import { pluralise } from '$lib/client/utils/typography';

  export let ask;

  let showTerms = false;
  let consentToTerms = false;
  const artist = ask.context;
  const dispatch = createEventDispatcher();
  const plural = pluralise(artist.name);
</script>

<Title>{ask.title ? ask.title : `Join ${plural} Mailing List`}</Title>
<Content>
  <p>{ask.content}</p>
  {#if showTerms}
    <h3>Terms and Conditions</h3>
    <ul class="u-p-none">
      <li>
        By clicking Sign Up, you consent for Most Rated to share your e-mail address with {
          artist.name} (the 'Artist') for marketing purposes.
      </li>
      <li>
        Most Rated is not responsible for the content or frequency of the Artist's marketing emails.
      </li>
      <li>
        To unsubscribe from the Artist's marketing communications, you must contact the Artist
        directly or use the unsubscribe link provided in their emails.
      </li>
      <li>
        Most Rated will not be involved in managing or processing communications from this artist.
      </li>
    </ul>

    {#if ask.privacy_policy_url}
      <h3>Privacy Policy</h3>
      <p>
        Learn more about how {artist.name} will use your data by reading their <a
          href={ask.privacy_policy_url}
          class="link"
          target="_blank"
          rel="noopener">Privacy Policy.</a
        >
      </p>{/if}

    <FormField>
      <Checkbox id="consent" touch bind:checked={consentToTerms} />

      <span slot="label"
        >I agree to receive marketing emails from {artist.name} and consent to my email address
        being shared with them for this purpose.</span
      >
    </FormField>
  {/if}

  <nav class="actions b--secondary b--solid-t-tiny u-mt u-pt">
    <slot name="actions" />

    {#if showTerms}
      <Button
        class="complete-ask"
        color="primary"
        variant="raised"
        on:click={() => dispatch('completed')}
        disabled={!consentToTerms}
      >
        <Label>Sign Up</Label>
        <Icon class="material-icons">navigate_next</Icon></Button
      >
    {:else}
      <Button
        class="show-terms"
        variant="raised"
        color="primary"
        on:click={() => (showTerms = true)}>Sign up for {plural} Mailing List</Button
      >
    {/if}
  </nav>
</Content>
